// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/Nexa-Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/Nexa-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/fonts/Cormorant-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/fonts/Cormorant-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/fonts/Cormorant-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/fonts/Cormorant-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/fonts/Cormorant-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../assets/fonts/Bruney.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../assets/fonts/GeneralSans-Extralight.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../assets/fonts/GeneralSans-Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../assets/fonts/GeneralSans-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../assets/fonts/GeneralSans-Semibold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../../assets/fonts/GeneralSans-Bold.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Nexa";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-style: normal;
  font-weight: 400;
}
@font-face {
  font-family: "Nexa";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-style: normal;
  font-weight: 600;
}
@font-face {
  font-family: "Cormorant";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-style: normal;
  font-weight: 300;
}
@font-face {
  font-family: "Cormorant";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  font-style: normal;
  font-weight: 400;
}
@font-face {
  font-family: "Cormorant";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  font-style: normal;
  font-weight: 500;
}
@font-face {
  font-family: "Cormorant";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  font-style: normal;
  font-weight: 600;
}
@font-face {
  font-family: "Cormorant";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  font-style: normal;
  font-weight: 700;
}
@font-face {
  font-family: "Bruney";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  font-style: normal;
  font-weight: 300;
}
@font-face {
  font-family: "GeneralSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  font-style: normal;
  font-weight: 300;
}
@font-face {
  font-family: "GeneralSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  font-style: normal;
  font-weight: 400;
}
@font-face {
  font-family: "GeneralSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  font-style: normal;
  font-weight: 500;
}
@font-face {
  font-family: "GeneralSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  font-style: normal;
  font-weight: 600;
}
@font-face {
  font-family: "GeneralSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  font-style: normal;
  font-weight: 700;
}
*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
}

body {
  font-family: GeneralSans, sans-serif;
}

.footer {
  background-color: #2f020c;
}
.footer__parent {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 1rem;
  max-width: 600px;
  margin: auto;
}
@media (min-width: 500px) {
  .footer__parent {
    padding: 1rem 2rem;
    max-width: 700px;
  }
}
@media (min-width: 768px) {
  .footer__parent {
    padding: 2rem 0 1rem 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
}
@media (min-width: 900px) {
  .footer__parent {
    padding: 1rem 2rem;
    max-width: 800px;
  }
}
@media (min-width: 1000px) {
  .footer__parent {
    padding: 1rem 2rem;
    max-width: 900px;
  }
}
@media (min-width: 1280px) {
  .footer__parent {
    max-width: 1200px;
  }
}
.footer__phoneparent, .footer__emailparent {
  display: flex;
  flex-direction: row;
}
.footer__phoneparent--text, .footer__emailparent--text {
  padding-bottom: 1rem;
}
.footer__title {
  padding-bottom: 1rem;
  color: white;
  font-size: 1.2rem;
  font-weight: 600;
}
@media (min-width: 768px) {
  .footer__title {
    font-size: 1.5rem;
    font-weight: 400;
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
}
.footer__phone, .footer__email {
  color: white;
  font-size: 0.9rem;
}
@media (min-width: 768px) {
  .footer__phone, .footer__email {
    font-size: 1rem;
  }
}
.footer__phone {
  padding-bottom: 0.5rem;
}
.footer__email {
  margin-bottom: 1rem;
}
.footer__icon, .footer__icon--insta {
  width: 1.3rem;
  height: 1.3rem;
  margin-right: 0.5rem;
}
@media (min-width: 768px) {
  .footer__icon, .footer__icon--insta {
    width: 2rem;
    height: 2rem;
    margin-right: 1rem;
    margin-bottom: 1rem;
  }
}
.footer__icon--insta {
  margin-right: 0.5rem;
  margin-top: 0.5rem;
  margin-bottom: 1rem;
}
.footer__icon--instatext {
  color: white;
  padding-bottom: 0.5rem;
  font-size: 0.77rem;
}
@media (min-width: 768px) {
  .footer__icon--instatext {
    padding-bottom: 0.5rem;
  }
}
.footer__icon--instaparent {
  display: flex;
  align-items: center;
}
.footer__icon--fbparent {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.footer__logo {
  cursor: pointer;
  width: 90%;
  margin-left: 1rem;
}
@media (min-width: 400px) {
  .footer__logo {
    padding-left: 1rem;
    width: 10rem;
  }
}
@media (min-width: 768px) {
  .footer__logo {
    width: 13rem;
  }
}
.footer__container1 {
  padding: 0;
  max-width: 500px;
}
@media (min-width: 768px) {
  .footer__container1 {
    max-width: 85%;
  }
}
.footer__copyright {
  color: white;
  font-size: 0.8rem;
  padding-top: 1rem;
}
.footer__copyrightparent {
  padding-bottom: 1rem;
  padding-left: 1rem;
}
.footer__logoreplacement {
  font-size: 2.5rem;
  color: rgb(243, 226, 201);
  font-family: Bruney;
}`, "",{"version":3,"sources":["webpack://./src/styles/partials/_typography.scss","webpack://./src/components/Footer/Footer.scss","webpack://./src/styles/partials/_global.scss","webpack://./src/styles/partials/_variables.scss","webpack://./src/styles/partials/_mixins.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,mBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,wBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,wBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,wBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,wBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,wBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,qBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,0BAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,0BAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,0BAAA;EACA,6CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,0BAAA;EACA,6CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,0BAAA;EACA,6CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ACzEA;;;EAGI,sBAAA;EACA,SAAA;AD2EJ;;ACzEA;EACI,oCAAA;AD4EJ;;AAlFA;EACI,yBEKc;AFgFlB;AApFI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;AAsFR;AArFQ;EAPJ;IAQQ,kBAAA;IACA,gBAAA;EAwFV;AACF;AGtGI;EHIA;IAYQ,sBAAA;IACA,aAAA;IACA,mBAAA;IACA,8BAAA;EA0FV;AACF;AAzFQ;EAjBJ;IAkBQ,kBAAA;IACA,gBAAA;EA4FV;AACF;AA3FQ;EArBJ;IAsBQ,kBAAA;IACA,gBAAA;EA8FV;AACF;AGrHI;EHDA;IA0BQ,iBAAA;EAgGV;AACF;AA9FI;EACI,aAAA;EACA,mBAAA;AAgGR;AA/FQ;EACI,oBAAA;AAiGZ;AA9FI;EACI,oBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;AAgGR;AG5II;EHwCA;IAMQ,iBAAA;IACA,gBAAA;IACA,iBAAA;IACA,oBAAA;EAkGV;AACF;AAhGI;EACI,YAAA;EACA,iBAAA;AAkGR;AGxJI;EHoDA;IAIQ,eAAA;EAoGV;AACF;AAlGI;EACI,sBAAA;AAoGR;AAlGI;EACI,mBAAA;AAoGR;AAlGI;EACI,aAAA;EACA,cAAA;EACA,oBAAA;AAoGR;AGxKI;EHiEA;IAKQ,WAAA;IACA,YAAA;IACA,kBAAA;IACA,mBAAA;EAsGV;AACF;AAnGQ;EACI,oBAAA;EACA,kBAAA;EACA,mBAAA;AAqGZ;AAnGQ;EACI,YAAA;EACA,sBAAA;EACA,kBAAA;AAqGZ;AG1LI;EHkFI;IAKQ,sBAAA;EAuGd;AACF;AApGQ;EACI,aAAA;EACA,mBAAA;AAsGZ;AApGQ;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;AAsGZ;AAnGI;EACI,eAAA;EACA,UAAA;EACA,iBAAA;AAqGR;AApGQ;EAJJ;IAKQ,kBAAA;IACA,YAAA;EAuGV;AACF;AGnNI;EHqGA;IASQ,YAAA;EAyGV;AACF;AAvGI;EACI,UAAA;EACA,gBAAA;AAyGR;AG5NI;EHiHA;IAIQ,cAAA;EA2GV;AACF;AAzGI;EACI,YAAA;EACA,iBAAA;EACA,iBAAA;AA2GR;AAzGI;EACI,oBAAA;EACA,kBAAA;AA2GR;AAzGI;EACI,iBAAA;EACA,yBEzHU;EF0HV,mBAAA;AA2GR","sourcesContent":["@font-face{\n    font-family: \"Nexa\";\n    src: url(../../assets/fonts/Nexa-Light.otf);\n    font-style: normal;\n    font-weight: 400;\n}\n@font-face{\n    font-family: \"Nexa\";\n    src: url(../../assets/fonts/Nexa-Bold.otf);\n    font-style: normal;\n    font-weight: 600;\n}\n@font-face{\n    font-family: \"Cormorant\";\n    src: url(../../assets/fonts/Cormorant-Light.ttf);\n    font-style: normal;\n    font-weight: 300;\n}\n@font-face{\n    font-family: \"Cormorant\";\n    src: url(../../assets/fonts/Cormorant-Regular.ttf);\n    font-style: normal;\n    font-weight: 400;\n}\n@font-face{\n    font-family: \"Cormorant\";\n    src: url(../../assets/fonts/Cormorant-Medium.ttf);\n    font-style: normal;\n    font-weight: 500;\n}\n@font-face{\n    font-family: \"Cormorant\";\n    src: url(../../assets/fonts/Cormorant-SemiBold.ttf);\n    font-style: normal;\n    font-weight: 600;\n}\n@font-face{\n    font-family: \"Cormorant\";\n    src: url(../../assets/fonts/Cormorant-Bold.ttf);\n    font-style: normal;\n    font-weight: 700;\n}\n@font-face{\n    font-family: \"Bruney\";\n    src: url(../../assets/fonts/Bruney.ttf);\n    font-style: normal;\n    font-weight: 300;\n}\n@font-face{\n    font-family: \"GeneralSans\";\n    src: url(../../assets/fonts/GeneralSans-Extralight.otf);\n    font-style: normal;\n    font-weight: 300;\n}\n@font-face{\n    font-family: \"GeneralSans\";\n    src: url(../../assets/fonts/GeneralSans-Light.otf);\n    font-style: normal;\n    font-weight: 400;\n}\n@font-face{\n    font-family: \"GeneralSans\";\n    src: url(../../assets/fonts/GeneralSans-Regular.otf);\n    font-style: normal;\n    font-weight: 500;\n}\n@font-face{\n    font-family: \"GeneralSans\";\n    src: url(../../assets/fonts/GeneralSans-Semibold.otf);\n    font-style: normal;\n    font-weight: 600;\n}\n@font-face{\n    font-family: \"GeneralSans\";\n    src: url(../../assets/fonts/GeneralSans-Bold.otf);\n    font-style: normal;\n    font-weight: 700;\n}\n","@use \"../../styles/partials/variables\" as *;\n@use \"../../styles/partials/typography\" as *;\n@use \"../../styles/partials/mixins\" as *;\n@use \"../../styles/partials/_global\" as *;\n\n.footer{\n    background-color: $xeus-darkmaroon;\n    &__parent{\n        display: flex;\n        flex-direction: row;\n        justify-content: space-between;\n        padding: 1rem;\n        max-width: 600px;\n        margin: auto;\n        @media (min-width: 500px) {\n            padding: 1rem 2rem;\n            max-width: 700px;      \n        }\n        @include tablet-and-desktop{\n            padding: 2rem 0 1rem 0;\n            display: flex;\n            flex-direction: row;\n            justify-content: space-between;\n        }\n        @media (min-width: 900px) {\n            padding: 1rem 2rem;\n            max-width: 800px;      \n        }\n        @media (min-width: 1000px) {\n            padding: 1rem 2rem;\n            max-width: 900px;      \n        }\n        @include desktop{\n            max-width: 1200px;    \n        }\n    }\n    &__phoneparent, &__emailparent{\n        display: flex;\n        flex-direction: row;\n        &--text{\n            padding-bottom: 1rem;\n        }\n    }\n    &__title{\n        padding-bottom: 1rem;\n        color: white;\n        font-size: 1.2rem;\n        font-weight: 600;\n        @include tablet-and-desktop{\n            font-size: 1.5rem;\n            font-weight: 400;\n            padding-top: 1rem;\n            padding-bottom: 1rem;\n        }\n    }\n    &__phone, &__email{\n        color: white;\n        font-size: 0.9rem;\n        @include tablet-and-desktop{\n            font-size: 1rem;\n        }\n    }\n    &__phone{\n        padding-bottom: 0.5rem;\n    }\n    &__email{\n        margin-bottom: 1rem;\n    }\n    &__icon, &__icon--insta{\n        width: 1.3rem;\n        height: 1.3rem;\n        margin-right: 0.5rem;\n        @include tablet-and-desktop{\n            width: 2rem;\n            height: 2rem;\n            margin-right: 1rem;\n            margin-bottom: 1rem;\n        }\n    }\n    &__icon{\n        &--insta{\n            margin-right: 0.5rem;\n            margin-top: 0.5rem;\n            margin-bottom: 1rem;\n        }\n        &--instatext{\n            color: white;\n            padding-bottom: 0.5rem;\n            font-size: 0.77rem;\n            @include tablet-and-desktop{\n                padding-bottom: 0.5rem;\n            }\n\n        }\n        &--instaparent{\n            display: flex;\n            align-items:center;\n        }\n        &--fbparent{\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n        }\n    }\n    &__logo{\n        cursor: pointer;\n        width: 90%;\n        margin-left: 1rem;\n        @media (min-width: 400px) {\n            padding-left: 1rem;\n            width: 10rem;       \n        }\n        @include tablet-and-desktop{\n            width: 13rem;\n        }\n    }\n    &__container1{\n        padding: 0;\n        max-width: 500px;\n        @include tablet-and-desktop{\n            max-width: 85%;\n        }\n    }\n    &__copyright{\n        color: white;\n        font-size: 0.8rem;\n        padding-top: 1rem;\n    }\n    &__copyrightparent{\n        padding-bottom: 1rem;\n        padding-left: 1rem;\n    }\n    &__logoreplacement{\n        font-size: 2.5rem;\n        color: $xeus-lightbeige;\n        font-family: Bruney;\n    }\n}","@use \"./variables\" as *;\n@use \"./typography\" as *;\n@use \"./mixins\" as *;\n\n*,\n*::before,\n*::after{\n    box-sizing: border-box;\n    margin: 0;\n}\nbody{\n    font-family: GeneralSans, sans-serif;\n}\n","$tablet-breakpoint: 768px;\n$desktop-breakpoint: 1280px;\n$max-width: 1195px;\n$mobile-header-fontsize: 1rem;\n$mobile-subheader-fontsize: 0.9rem;\n$mobile-content-fontsize: 0.8rem;\n$text-darkgray: rgb(39, 32, 32);\n$text-shadow: #3d3d3d;\n$button-color: #2f7fb0;\n$button-color-hover: #0c4f76;\n$website-darkgray: rgb(44, 43, 43);\n$xeus-darkmaroon: #2f020c;\n$xeus-mediumbeige: rgb(224, 196, 154);\n$xeus-lightbeige: rgb(243, 226, 201);\n$website-border-lightgray: rgb(238, 234, 234);\n","@use \"./variables\" as *;\n\n@mixin tablet-and-desktop {\n    @media (min-width: $tablet-breakpoint) {\n        @content;\n    }\n}\n@mixin desktop {\n    @media (min-width: $desktop-breakpoint) {\n        @content;\n    }\n}\n\n@mixin big-mobile-screen {\n    @media (min-width: 450px) {\n        @content;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
